"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationDot = void 0;
var React = __importStar(require("react"));
var theme_1 = require("../theme");
var NotificationDotBase_1 = require("./NotificationDotBase");
var notificationDots = {
    DEFAULT: {
        backgroundColor: 'blue500',
    },
    DEFAULT_DARK: {
        backgroundColor: 'blue300',
        border: "".concat(theme_1.spacing.space2, " solid ").concat(theme_1.colors.n900),
    },
    DEFAULT_DARK_ACTIVE: {
        backgroundColor: 'blue300',
        border: "".concat(theme_1.spacing.space2, " solid ").concat(theme_1.colors.n600),
    },
};
var NotificationDot = function (_a) {
    var _b = _a.mode, mode = _b === void 0 ? 'DEFAULT' : _b, rest = __rest(_a, ["mode"]);
    var _c = notificationDots[mode], backgroundColor = _c.backgroundColor, border = _c.border;
    return (React.createElement(NotificationDotBase_1.NotificationDotBase, __assign({ backgroundColor: backgroundColor, border: border }, rest)));
};
exports.NotificationDot = NotificationDot;
//# sourceMappingURL=index.js.map